import View from './Actions';
import enhancer from './Actions.enhancer';

const Actions = enhancer(View);

export default Actions;
